var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.58,
    height: 30.58,
    rx: 6.75,
    fill: "black",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0749 22.0502C18.1756 22.0502 21.4999 18.7259 21.4999 14.6252C21.4999 10.5245 18.1756 7.2002 14.0749 7.2002C9.97419 7.2002 6.6499 10.5245 6.6499 14.6252C6.6499 18.7259 9.97419 22.0502 14.0749 22.0502Z",
    stroke: "#909090",
    strokeWidth: 1.37654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9128 23.7006C22.5962 23.7006 23.1503 23.1465 23.1503 22.4631C23.1503 21.7796 22.5962 21.2256 21.9128 21.2256C21.2293 21.2256 20.6753 21.7796 20.6753 22.4631C20.6753 23.1465 21.2293 23.7006 21.9128 23.7006Z",
    stroke: "#909090",
    strokeWidth: 1.37654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearch);
export default __webpack_public_path__ + "static/media/newSearch.2cbb3dc1592e47bba5999f1479596957.svg";
export { ForwardRef as ReactComponent };